// ./utils/api-endpoints/task.js

import { AddTaskFollowUp } from "src/actions/task/taskActions";

export const taskEndpoints = {
    delete: '/api/Task/Delete',
    getById: '/api/Task/',
    category: '/api/Task/Category',
    status: '/api/Task/Status',
    taskType: '/api/Task/TaskType',
    dateFilter: '/api/Task/DateFilter',
    insert: '/api/Task/Insert',
    filter: '/api/Task/Filter',
    filterTeams: '/api/Task/FilterTeams',
    getAllBySP: '/api/Task/GetAllBySP',
    getAllSubTaskBySP: '/api/Task/GetAllSubTaskBySP',
    getAllTaskAndSubTaskBySP: '/api/Task/GetAllTaskAndSubTaskBySP',
    workflow: '/api/Task/WorkFlow',
    update: '/api/Task/Update?',
    archive: '/api/Task/Archive',
    taskStatus: '/api/Task/TaskStatus',
    subTaskMemberStatus: '/api/Task/SubTaskMemberStatus',
    taskUpdateNotifyNCalender: '/api/Task/TaskUpdateNotifyNCalender',
    taskMemberStatus: '/api/Task/TaskMemberStatus',
    taskMemberReopen: '/api/Task/TaskMemberReopen',
    percentageUpdate: '/api/Task/PercentageUpdate',
    taskTimeline: '/api/TaskTimeline/GetAll' ,
    FollowUps : 'api/ReFollowUp/Filter',
    AddFollowUp : 'api/ReFollowUp/Insert' ,
    upload : 'api/TaskFile/Upload',
    CreateFollowUpWithRefollowUp : 'api/FollowUp/CreateFollowUpWithRefollowUp',
    GetProjectDropDownList : 'api/Project/DropDown' ,
    UpdateTaskPercentage : 'api/Task/PercentageUpdate',
    getAllSubTasksBySP : 'api/Task/GetAllSubTaskBySP',
    addTodo : 'api/TaskActivity/BulkInsert' ,
    statusUpdate  : 'api/TaskActivity/StatusUpdate',
    taskFileDelete : 'api/TaskFile/Delete' ,
    deleteTaskActivity : 'api/TaskActivity/Delete'

  };
  